package kz.dentalcrm.app.data.network

import io.ktor.client.HttpClient
import io.ktor.client.request.header
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import io.ktor.http.headers
import io.ktor.http.path
import kz.dentalcrm.app.core.network.handle
import kz.dentalcrm.app.core.storage.Storage
import kz.dentalcrm.app.data.network.request_model.StoreTreatmentRequest
import kz.dentalcrm.app.data.network.request_model.TreatmentRequest
import kz.dentalcrm.app.data.network.request_model.UpdateTreatmentRequest
import kz.dentalcrm.app.data.network.response_model.protocol_templates.ProtocolResponse
import kz.dentalcrm.app.data.network.response_model.protocol_templates.TemplateItem
import kz.dentalcrm.app.data.network.response_model.protocol_templates.TreatmentDetailResponseItem

class TreatmentApi(
    private val httpClient: HttpClient,
    private val storage: Storage
) {

    suspend fun getTreatments(
        page: Int,
        search: String = ""
    ) = httpClient.handle<ProtocolResponse?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/treatments/templates-paginate"
            )
            parameters.append("page", page.toString())
            if (search.isNotEmpty()) {
                parameters.append("search", search)
            }
        }
        method = HttpMethod.Get
    }

    suspend fun addTreatment(
        name: String,
        code: String,
        id: Int?
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/treatments/templates"
            )
            setBody(
                TreatmentRequest(
                    name = name,
                    code = code,
                    id = id
                )
            )
        }
        method = HttpMethod.Post
    }

    suspend fun deleteTreatment(
        id: Int
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/treatments/templates/$id"
            )
        }
        method = HttpMethod.Delete
    }

    suspend fun getTreatmentDetails(
        id: String
    ) = httpClient.handle<List<TreatmentDetailResponseItem>?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/treatments/templates/$id"
            )
        }
        method = HttpMethod.Get
    }

    suspend fun updateTreatmentDetails(
        templateId: Int,
        items: List<TreatmentDetailResponseItem>
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/treatments/types/list"
            )
            setBody(
                UpdateTreatmentRequest(
                    templateId = templateId,
                    types = items
                )
            )
        }
        method = HttpMethod.Post
    }

    suspend fun getTemplates() = httpClient.handle<List<TemplateItem>> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/treatments/templates"
            )
        }
        method = HttpMethod.Get
    }

    suspend fun storeTreatment(
        request: StoreTreatmentRequest
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/treatments/store/list"
            )
            setBody(request)
        }
        method = HttpMethod.Post
    }
}